module.exports = __webpack_public_path__ + "img/Icon_Score.9acd015f.svg";